import { 
  CUSTOMER_FIELD_SUCCESS, 
  CUSTOMER_FIELD_REQUEST_BY_ENTITY_SUCCESS 
} from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case CUSTOMER_FIELD_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  case CUSTOMER_FIELD_REQUEST_BY_ENTITY_SUCCESS:
    return {
      ...state,
      [action.entityName]: action.payload
    };
  default:
    return state;
  }
}